import { Spin } from 'antd';
import { Suspense, lazy } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import Layout from '../../components/Layout';
import Menu from '../../components/Layout/Menu';

const StatesContent = lazy(() => import('../../components/Pages/States'));

export default function States(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: Topics List page`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <Suspense fallback={<Spin spinning indicator={<LoadingOutlined spin />} />}>
        <StatesContent />
      </Suspense>
    </Layout>
  );
}
